import MicaTypes from 'constants/MicaTypes'
import DataTypes from 'constants/DataTypes'
import DataLimits from 'constants/DataLimits'
import { isIndicator } from 'utils/data'

export const isMainIndicator = (type, system, isChannel, mainIndicators) => {
  if (isChannel) {
    return true
  }

  const {
    deskMainIndicator,
    liteMainIndicator,
    micaMainIndicator,
    wellMainIndicator,
    plusMainIndicator
  } = mainIndicators

  switch (system.micaType) {
    case MicaTypes.MICA_LITE:
      if (liteMainIndicator === DataTypes.VENTILATION_INDICATOR)
        return type === DataTypes.VENTILATION_INDICATOR
      if (liteMainIndicator === DataTypes.THERMAL_INDICATOR)
        return type === DataTypes.THERMAL_INDICATOR
      return type === DataTypes.COVID_19
    case MicaTypes.MICA_MINI:
      return type === DataTypes.THERMAL_INDICATOR
    case MicaTypes.MICA_DESK:
      if (deskMainIndicator === DataTypes.THERMAL_INDICATOR)
        return type === DataTypes.THERMAL_INDICATOR
      return type === DataTypes.VENTILATION_INDICATOR
    case MicaTypes.MICA:
      if (micaMainIndicator === DataTypes.VENTILATION_INDICATOR)
        return type === DataTypes.VENTILATION_INDICATOR
      if (micaMainIndicator === DataTypes.THERMAL_INDICATOR)
        return type === DataTypes.THERMAL_INDICATOR
      if (micaMainIndicator === DataTypes.COVID_19) return type === DataTypes.COVID_19
      return type === DataTypes.IAQ
    case MicaTypes.MICA_WELL:
      if (wellMainIndicator === DataTypes.VENTILATION_INDICATOR)
        return type === DataTypes.VENTILATION_INDICATOR
      if (wellMainIndicator === DataTypes.THERMAL_INDICATOR)
        return type === DataTypes.THERMAL_INDICATOR
      if (wellMainIndicator === DataTypes.COVID_19) return type === DataTypes.COVID_19
      return type === DataTypes.IAQ
    case MicaTypes.MICA_PLUS:
      if (plusMainIndicator === DataTypes.VENTILATION_INDICATOR)
        return type === DataTypes.VENTILATION_INDICATOR
      if (plusMainIndicator === DataTypes.THERMAL_INDICATOR)
        return type === DataTypes.THERMAL_INDICATOR
      if (plusMainIndicator === DataTypes.COVID_19) return type === DataTypes.COVID_19
      return type === DataTypes.IAQ
    default:
      return type === DataTypes.IAQ
  }
}

export const getIndicatorTip = (type, translate) => {
  switch (type) {
    case DataTypes.COVID_19:
      return translate('virusIndicatorTitle')
    case DataTypes.VENTILATION_INDICATOR:
      return translate('ventilationIndicatorTitle')
    case DataTypes.THERMAL_INDICATOR:
      return translate('thermalIndicatorTitle')
    case DataTypes.MOLD_INDICATOR:
      return translate('moldIndicatorTitle')
    case DataTypes.GO_IAQS:
      return translate('goIaqsIndicatorTitle')
    default:
      return translate('iaqIndicatorTitle')
  }
}

export const getMoreInformationUrl = type => {
  switch (type) {
    case DataTypes.COVID_19:
      return 'https://inbiotair.com/wikinbiot/indicador-resistencia-virus'
    case DataTypes.VENTILATION_INDICATOR:
      return 'https://www.inbiotair.com/wikinbiot/indicador-eficacia-ventilacion'
    case DataTypes.THERMAL_INDICATOR:
      return 'https://inbiotair.com/wikinbiot/indicadore-confort-termohigrometrico'
    case DataTypes.MOLD_INDICATOR:
      return 'https://www.inbiotair.com/wikinbiot/resistance-to-mold-growth-indicator'
    default:
      return 'https://inbiotair.com/wikinbiot/indicador-calidad-de-aire-interior'
  }
}

export const getFlexBasis = numberOfIndicators => {
  if (numberOfIndicators === 1) return '100%'
  if (numberOfIndicators === 2) return '45%'
  if (numberOfIndicators === 3) return '30%'
  if (numberOfIndicators === 4) return '45%'
  if (numberOfIndicators >= 5) return '30%'
}

export const getIndicatorsPerRow = numberOfIndicators => {
  return numberOfIndicators === 4 ? 2 : 3
}

export const isIndicatorInLastRow = (index, numberOfIndicators) => {
  const indicatorsPerRow = getIndicatorsPerRow(numberOfIndicators)
  const firstIndexInLastRow =
    Math.floor((numberOfIndicators - 1) / indicatorsPerRow) * indicatorsPerRow

  return index >= firstIndexInLastRow
}

export const getGoIaqsCategory = value => {
  if (value >= DataLimits.GO_IAQS_YELLOW) return 'Good'
  if (value >= DataLimits.GO_IAQS_RED) return 'Moderate'
  return 'Unhealthy'
}

// This function returns the config for GO IAQS and an empty object for other types
export const getGoIaqsMeterProps = type => {
  if (type === DataTypes.GO_IAQS) {
    return {
      maxValue: DataLimits.GO_IAQS_MAX,
      levels: { red: DataLimits.GO_IAQS_RED, yellow: DataLimits.GO_IAQS_YELLOW },
      topColor: '#007AFF'
    }
  }
  return {}
}

export const getIndicatorsWithMainFirst = (sortedData, isMainIndicatorForSystem) => {
  const indicators = sortedData.filter(item => {
    // dominant pollutant is shown as text
    if (item.type === DataTypes.GO_IAQS_DOMINANT) return false
    return isIndicator(item.type) && item.measurements.length > 0
  })

  const mainIndex = indicators.findIndex(item => isMainIndicatorForSystem(item.type))
  if (mainIndex > 0) {
    const [mainItem] = indicators.splice(mainIndex, 1)
    indicators.unshift(mainItem)
  }

  // check if mold indicator is in the list, if so, move it to the end of the list
  const moldIndex = indicators.findIndex(item => item.type === DataTypes.MOLD_INDICATOR)
  // not found
  if (moldIndex === -1) {
    const moldIndicatorItem = { type: DataTypes.MOLD_INDICATOR, measurements: [{ value: 'p' }] }
    indicators.push(moldIndicatorItem)
  }

  return indicators
}
